import { Dimensions } from 'react-native'
import { NoraHomeWalkthroughLayout } from './types'

export const getNoraHomeWalkthroughLayout = (
  {
    width,
    height,
    fontScale,
  }: {
    width: number
    height: number
    fontScale: number
  } = Dimensions.get('window'),
): NoraHomeWalkthroughLayout => {
  const isCompact = width <= 340 || height <= 700 || fontScale >= 1.2

  return {
    isCompact,
    standalonePadding: isCompact ? 16 : 24,
    pageControlBottom: isCompact ? 48 : 64,
    cardMaxWidth: Math.min(width - (isCompact ? 32 : 48), isCompact ? 312 : 328),
    cardPadding: isCompact ? 18 : 24,
    cardTopPadding: isCompact ? 26 : 32,
    cardGap: isCompact ? 12 : 18,
    cardIconSize: isCompact ? 50 : 64,
    iconSize: isCompact ? 24 : 30,
    bodyLineHeight: isCompact ? 21 : 24,
    actionChipHeight: isCompact ? 40 : 48,
    actionStackGap: isCompact ? 7 : 10,
  }
}
